<template>
  <div class="row-history-entry__field-content">
    <div v-if="hasBeforeValue">
      <div class="row-history-entry__diff row-history-entry__diff--removed">
        {{ formattedNumber(entry.before[fieldIdentifier]) }}
      </div>
    </div>
    <div v-if="hasAfterValue">
      <div class="row-history-entry__diff row-history-entry__diff--added">
        {{ formattedNumber(entry.after[fieldIdentifier]) }}
      </div>
    </div>
  </div>
</template>

<script>
import { formatDecimalNumber } from '@baserow/modules/database/utils/number'

export default {
  name: 'RowHistoryFieldNumber',
  props: {
    entry: {
      type: Object,
      required: true,
    },
    fieldIdentifier: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    hasBeforeValue() {
      return this.hasHistoryValue(this.entry.before)
    },
    hasAfterValue() {
      return this.hasHistoryValue(this.entry.after)
    },
  },
  methods: {
    hasHistoryValue(side) {
      if (
        !side ||
        !Object.prototype.hasOwnProperty.call(side, this.fieldIdentifier)
      ) {
        return false
      }
      const value = side[this.fieldIdentifier]
      return value !== null && value !== undefined && value !== ''
    },
    formattedNumber(value) {
      const metadata = this.entry.fields_metadata[this.fieldIdentifier]
      return formatDecimalNumber(metadata, value)
    },
  },
}
</script>
